import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeHeadComponent = (function () {
    function CasePracticeHeadComponent(apiService, route, router) {
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.closeClick = new EventEmitter();
        this.onReviewConversation = new EventEmitter();
        this.progressTheme = "box";
    }
    CasePracticeHeadComponent.prototype.ngOnInit = function () {
    };
    CasePracticeHeadComponent.prototype.close = function ($event) {
        this.closeClick.emit();
        $event.stopPropagation();
    };
    CasePracticeHeadComponent.prototype.reviewConversation = function () {
        this.onReviewConversation.emit();
    };
    return CasePracticeHeadComponent;
}());
export { CasePracticeHeadComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-head/case-practice-head.component.ts.pre-build-optimizer.js